import {
  MainPhotoSection,
  HowToStartSection,
  WebTerminalSection,
  AdvantagesSection,
  InvestSection,
  IncreaseSection,
  EconomicCalendarSection,
} from "./MainPageStyles";
import { ECONOMIC__CALENDAR } from "../../widgets/Widgets";
import MainPhoto from "../../images/MainPhoto.jpg";
import { MStartTraidingCard } from "../../components/Cards/StartTraidingCard/StartTraidingCard";
import { MAdvantagesCard } from "../../components/Cards/AdvantagesCard/AdvantagesCard";
import StartTradingFirstImg from "../../images/CardsImages/StartCardImages/firstCard1.png";
import StartTradingSecondImg from "../../images/CardsImages/StartCardImages/secondCard.png";
import WebTerminal from "../../images/webTerminalPhoto.png";
import FirstIconBlueBorderCard from "../../images/CardsImages/CardsWithBlueBorder/firstCardIcon.svg";
import SecondIconBlueBorderCard from "../../images/CardsImages/CardsWithBlueBorder/secondCardIcon.svg";
import ThirdIconBlueBorderCard from "../../images/CardsImages/CardsWithBlueBorder/thirdCardIcon.svg";
import FoursIconBlueBorderCard from "../../images/CardsImages/CardsWithBlueBorder/fourCardIcon.svg";
import LaptopPhoto from "../../images/laptop__photo.png";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  animationFromTheSide,
  arrAnimation,
  arrAnimationFromTheSide,
  mainAnimation,
} from "../../animations/animations";
import { useTranslation } from "react-i18next";
import { generateLink } from "../../functions/routingFuntion";
import { useAppSelector } from "../../store/hooks";

export const MainPage = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection
        style={{
          backgroundImage: `url(${MainPhoto})`,
        }}
      >
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart"
        >
          <motion.h1 custom={1} variants={arrAnimationFromTheSide}>
            {t("mainPage.title1")}
          </motion.h1>
          <motion.p
            custom={2}
            variants={arrAnimationFromTheSide}
            className="big__text"
          >
            {t("mainPage.title21")}
            <br />
            {t("mainPage.title22")}
          </motion.p>
          <motion.div custom={3} variants={arrAnimationFromTheSide}>
            <NavLink to="/auth/login" className="white__button flex__center">
              {t("mainPage.titleBtn")}
            </NavLink>
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <HowToStartSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("mainPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="flex__between cards__container"
          >
            <MStartTraidingCard
              custom={1}
              variants={arrAnimation}
              title="1"
              img={`${StartTradingFirstImg}`}
              text={`${t("mainPage.blockInfo11")}`}
              imgDisplay="block"
            />
            <motion.div custom={2} variants={arrAnimation} className="middle">
              <MStartTraidingCard
                title="2"
                text={`${t("mainPage.blockInfo12")}`}
                imgDisplay="none"
              />
              <MStartTraidingCard
                title="3"
                text={`${t("mainPage.blockInfo13")}`}
                imgDisplay="none"
              />
            </motion.div>
            <MStartTraidingCard
              custom={3}
              variants={arrAnimation}
              title="4"
              img={`${StartTradingSecondImg}`}
              text={`${t("mainPage.blockInfo14")}`}
              imgDisplay="block"
            />
          </motion.div>
        </div>
      </HowToStartSection>
      <WebTerminalSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between web-terminal__container"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("mainPage.blockInfo2Tit")}</h2>
            <p className="big__text">{t("mainPage.blockInfo21")}</p>
            <p>{t("mainPage.blockInfo22")}</p>
            <NavLink className="white__button flex__center" to="/auth/login">
              {t("mainPage.blockInfo23")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </WebTerminalSection>
      <AdvantagesSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("mainPage.blockInfo3Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="flex__between"
          >
            <MAdvantagesCard
              custom={1}
              variants={arrAnimation}
              title={`${t("mainPage.blockInfo31Tit")}`}
              img={FirstIconBlueBorderCard}
              text={`${t("mainPage.blockInfo31")}`}
            />
            <MAdvantagesCard
              custom={2}
              variants={arrAnimation}
              title={`${t("mainPage.blockInfo32Tit")}`}
              img={SecondIconBlueBorderCard}
              text={`${t("mainPage.blockInfo32")}`}
            />
            <MAdvantagesCard
              custom={3}
              variants={arrAnimation}
              title={`${t("mainPage.blockInfo33Tit")}`}
              img={ThirdIconBlueBorderCard}
              text={`${t("mainPage.blockInfo33")}`}
            />
            <MAdvantagesCard
              custom={4}
              variants={arrAnimation}
              title={`${t("mainPage.blockInfo34Tit")}`}
              img={FoursIconBlueBorderCard}
              text={`${t("mainPage.blockInfo34")}`}
            />
          </motion.div>
        </div>
      </AdvantagesSection>
      <InvestSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between web-terminal__container"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("mainPage.blockInfo4Tit")}</h2>
            <p className="big__text">{t("mainPage.blockInfo41")}</p>
            <ul>
              <li>{t("mainPage.blockInfo4li1")}</li>
              <li>{t("mainPage.blockInfo4li2")}</li>
              <li>{t("mainPage.blockInfo4li3")}</li>
              <li>{t("mainPage.blockInfo4li4")}</li>
              <li>{t("mainPage.blockInfo4li5")}</li>
            </ul>
            <NavLink className="white__button flex__center" to="/auth/login">
              {t("mainPage.blockInfo42")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </InvestSection>
      <EconomicCalendarSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          variants={mainAnimation}
          className="container__standart"
        >
          <div className="economic__top flex__between">
            <h2>{t("mainPage.blockInfo5Tit")}</h2>
            <NavLink
              to={generateLink("/auth/login", language)}
              className="dark-blue__button"
            >
              {t("mainPage.blockInfo51")}
            </NavLink>
          </div>
          <div className="economic__bottom">
            <iframe
              src={ECONOMIC__CALENDAR}
              title="events TradingView widget"
              lang="en"
            ></iframe>
          </div>
        </motion.div>
      </EconomicCalendarSection>
      {/* <MarketDynamicsSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          variants={mainAnimation}
          className="container__standart"
        >
          <h2>Market dynamics</h2>
          <div className="section__frame">
            <iframe
              src={MARKET__DINAMICS}
              title="market overview TradingView widget"
              lang="en"
            ></iframe>
          </div>
        </motion.div>
      </MarketDynamicsSection> */}
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("mainPage.blockInfo6Tit")}</h2>
            <p className="big__text">{t("mainPage.blockInfo61")}</p>
            <NavLink className="white__button flex__center" to="/auth/login">
              {t("mainPage.blockInfo62")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="LaptopPhoto" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
    </main>
  );
};
